var map = {
	"./arrow.png": 74931,
	"./banner_bg.png": 16385,
	"./bg_token_01.png": 38911,
	"./bg_token_02.png": 27150,
	"./bg_token_03.png": 47757,
	"./bg_token_04.png": 19406,
	"./boxbg1.png": 68153,
	"./boxbg2.png": 40743,
	"./boxbg3.png": 24345,
	"./calender.png": 31433,
	"./close_icon.png": 82790,
	"./close_icon.svg": 66644,
	"./copy_icon.png": 77797,
	"./cta_02_bg.png": 48877,
	"./dash_bg.png": 99380,
	"./dash_icon_01.png": 85246,
	"./dash_icon_02.png": 44079,
	"./dash_icon_03.png": 38828,
	"./dash_icon_04.png": 69897,
	"./dash_icon_05.png": 57049,
	"./deposit_tables_bg.png": 68181,
	"./downarw.png": 96871,
	"./f1.png": 54017,
	"./f2.png": 997,
	"./f3.png": 63362,
	"./faqdown_arw.png": 91912,
	"./faqright_arw.png": 33650,
	"./faqside_img.png": 59411,
	"./feature_bg.png": 9531,
	"./group.png": 27531,
	"./how_work.png": 90544,
	"./how_work_shadow.png": 2477,
	"./income_plan_bg.png": 19340,
	"./join_now_icon.png": 5719,
	"./level.png": 18158,
	"./logo.png": 74427,
	"./logoicon.png": 60115,
	"./logoold.png": 26084,
	"./logout_btn.png": 23099,
	"./members.png": 85010,
	"./metamask.png": 58843,
	"./percent.png": 1915,
	"./polygon_logo.png": 4453,
	"./portis.png": 98668,
	"./q.png": 44245,
	"./recent_act_bg.png": 65962,
	"./rightarw.png": 82810,
	"./seemore_arw.png": 7469,
	"./seemore_arw1.png": 17198,
	"./slideleftarw.png": 18380,
	"./sliderightarw.png": 36352,
	"./staking_bg.png": 20346,
	"./torus.png": 51111,
	"./tree_icon.png": 7338,
	"./trustwallet.png": 89414,
	"./user_prf.png": 85528,
	"./wallet.png": 82106,
	"./wallet_icon.png": 39073,
	"./wallet_imgbtn.png": 66461,
	"./walletconnect.png": 16354
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 90990;